/*
  @ Add body class if:
  - scroll started
  - scrolled to bottom
*/

const ISMOBILE = window.matchMedia("only screen and (max-width: 992px)").matches
const ELEMENT = '.header'
const START_FIXED_CLASS = "HeaderStickyClass-fixed";
const START_VISIBLE_CLASS = "HeaderStickyClass-visible";

class HeaderStickyClass {
  constructor() {
    this.header = document.querySelector(ELEMENT);
    this.firstSection = document.querySelector('.site').children[0]

    if(!this.header || !this.firstSection || ISMOBILE){
      return false
    }

    this.START_FIXED = this.header.clientHeight;
    this.START_VISIBLE = this.START_FIXED + this.firstSection.clientHeight

    document.addEventListener("scroll", this.scrollHandler, {passive: true});
  }

  scrollHandler = () => {
    const top = document.documentElement.scrollTop;

    this.header.classList.toggle(START_FIXED_CLASS, top >= this.START_FIXED);
    this.header.classList.toggle('HeaderStickyClass-transition', top >= this.START_FIXED + 200);
    this.header.classList.toggle(START_VISIBLE_CLASS, top >= this.START_VISIBLE);

    this.oldScroll = top;

  };
}

new HeaderStickyClass();
